<p-button-group>
  <!--  @if (selectedUser() && selectedUser()?.nycProfile?.status === 'not-created') {-->
  <!--    <p-button-->
  <!--      (onClick)="onRegisterInNYCClick()"-->
  <!--      label="Register in NYC"-->
  <!--      icon="pi pi-plus"-->
  <!--      [disabled]="!selectedUser()"/>-->
  <!--  }-->
  <!--  <p-button (onClick)="onDeleteClick()"-->
  <!--            label="Delete"-->
  <!--            icon="pi pi-trash"-->
  <!--            [disabled]="!selectedUser()"-->
  <!--  />-->
</p-button-group>
@if (emails$ | async; as emails) {
  <p-table [value]="emails" selectionMode="single">
    <ng-template pTemplate="header">
      <tr>
        <th>Id</th>
        <th>Status</th>
        <th>Recipient</th>
        <th>Subject</th>
        <th>Timestamp</th>
        <th>Error message</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-email>
      <tr [pSelectableRow]="email">
        <td>{{ email.id }}</td>
        <td>
          <p-tag>{{ email.status }}</p-tag>
        </td>
        <td>{{ email.recipient }}</td>
        <td>{{ email.subject }}</td>
        <td>
          {{ email.timestamp | date: 'dd-MM-yyyy HH:mm:ss' }}
        </td>
        <td>
          @if (email.status !== 'processed') {
            <p-tag>{{ email.errorMessage }}</p-tag>
          }
        </td>
        <td>
          <p-button (onClick)="downloadEmail(email.s3Key)">
            Download
          </p-button>
      </tr>
    </ng-template>
  </p-table>
}
